import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const ManagerTopBarCloseIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon data-testid="managerTopBar close icon" viewBox="1 1 24 24" {...props}>
    <path
      d="M6 18L18 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 6.00003L18 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Icon>
);
